// extracted by mini-css-extract-plugin
module.exports = {"formCardContent":"FormCardContent_formCardContent__2slAU"};